import getClientId from '../storage/getClientId';
import getVisitorId from '../storage/getVisitorId';


export default function(element){
  window.dataLayer = window.dataLayer || [];

  let outbound = !(element.parentNode.ariaHasPopup);

  window.dataLayer.push({
    event: 'mainNav_selection',
    nav_level: element.parentNode.dataset.level,
    nav_path:  pathBuilder(element),
    visitor_id: getVisitorId(),
    client_id: getClientId(),
    outbound: outbound
  });
}

//builds click path based on link depth
const pathBuilder = (el) => {
  const nodeDepth = el.parentNode.dataset.level;
  let output =  nodeDepth == 0 ?  '' : extractCurrentPath(nodeDepth);
  if (output.length == 0) {
    output += el.innerText;
  } else {
    output = output + ' | ' + el.innerText;
  }
  return output;
};

// finds current path based on events that already exist in the data layer
const extractCurrentPath = (depth) => {
  const dataLayer = [...window.dataLayer].reverse();
  for (let i = 0; i <  dataLayer.length; i++){
    if (!dataLayer[i].nav_level) continue;
    if (dataLayer[i].nav_level  == depth - 1){
      return dataLayer[i].nav_path;
    }
  }
  return '';
};
